import React, { useState } from 'react';
import { connect } from 'react-redux';
import { removeHtmlTags } from '../../utilities/methods';
import * as rooRTC from "../../services/roomRTC";

import Card from '../Accordion/Card';

import "./Room.css";

const SingleNote = ({ question, roomId }) => {
    const [activeButton, setActiveButton] = useState(null);

    const handlerSendNote = (noteType, question) => {
        if (!question) return;

        const note = {
            A: question.nota_A,
            PA: question.nota_PA,
            I: question.nota_I
        }[noteType];

        // setActiveButton((prevState) => (prevState === noteType ? null : noteType));

        // rooRTC.sendProgressNoteDataChannel(question, note, noteType, roomId);

        if (activeButton === noteType) {
            // desmarcar -> remover
            setActiveButton(null);
            rooRTC.sendProgressNoteDataChannel(question, 0, null, roomId, "remove");
        } else {
            // marcar -> add/update
            setActiveButton(noteType);
            rooRTC.sendProgressNoteDataChannel(question, note, noteType, roomId);
        }
    };

    const getButtonStyle = (noteType) => {
        return activeButton === noteType
            ? {
                backgroundColor: activeButton === "A" ? "#C8E6C9" : activeButton === "PA" ? "#FFF9C4" : "#FFCCBC",
                color: "#000000"
            }
            : {
                backgroundColor: "#BBDEFB",
                color: "#000000",
                pointerEvents: "none"
            };
    };

    return (
        <Card className='col-md-12 mb-2 custom-card'>
            <Card.Body className='p-2'>
                <Card.Text>
                    <div className='row question_col_card_container'>
                        <div className='col-md-6 question_col_card_content question_col_card_start'>
                            <small className='question_col_card_paragraph'>{removeHtmlTags(question.perguntaRealizada)}</small>
                        </div>

                        <div className='col-md-2 question_note_card' onClick={() => handlerSendNote("A", question)}>
                            <span className='btn_question_note_card' style={getButtonStyle("A")}>A</span>
                        </div>

                        <div className='col-md-2 question_note_card' onClick={() => handlerSendNote("PA", question)}>
                            <span className='btn_question_note_card' style={getButtonStyle("PA")}>PA</span>
                        </div>

                        <div className='col-md-2 question_note_card' onClick={() => handlerSendNote("I", question)}>
                            <span className='btn_question_note_card' style={getButtonStyle("I")}>I</span>
                        </div>
                    </div>
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

const ScenarioNotes = ({ isRoomHost, questions, roomId }) => {
    if (!Array.isArray(questions) || questions.length === 0) {
        return null;
    }

    return (
        <div className='mb-2 col-md-12'>
            {
                isRoomHost &&
                questions.filter((question, index, self) => index === self.findIndex((q) => (
                    q.perguntaRealizada === question.perguntaRealizada
                )))
                    .filter((question) => !question.perguntaRealizada.toLocaleLowerCase().includes("impresso -"))
                    .map((question, index) => (
                        <SingleNote
                            key={`${question.perguntaRealizada}-${index}`}
                            question={question}
                            roomId={roomId}
                        />
                    ))
            }
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(ScenarioNotes);